import React from "react";

export default function Loading() {
  return (
    <div className="loading-state drop-shadow-md">
      <div className="flex flex-col gap-[14px] items-center justify-center">
        <p className="font-[600]">Yuklanmoqda...</p>
        <div className="loader" />
      </div>
    </div>
  );
}
